/* eslint-disable */

import { MAP_PROVIDER } from "../config/mapProvider";
import HereMapAdapter from "./HereMapAdapter";
import LeafletMapAdapter from "./LeafletMapAdapter";

// Cria o adapter de mapa de acordo com o flag em config/mapProvider.js.
export function createMapAdapter() {
  switch (MAP_PROVIDER) {
    case "here":
      return new HereMapAdapter();
    case "leaflet":
    default:
      return new LeafletMapAdapter();
  }
}

export { default as MapAdapter } from "./MapAdapter";
